<template>
  <div style="position: relative; display: flex">

    <!-- 图片上传 -->
    <div class="avatar-uploader el-upload imgLoadBox" v-show="imgUrl">
      <img class="avatar" :src="imgUrl" />
      <div class="imgBoxMask"></div>
      <i class="el-icon-delete" @click="removeImgHandle"></i>
      <i class="el-icon-zoom-in" style="margin-left: 25%"  @click="previewImg"></i>
    </div>

    <!-- 该处的elementUI只是为了显示原来的样式，不起任何上传的作用-->
    <el-upload
      ref="imgUpload"
      class="avatar-uploader"
      name="FileData"
      action=""
      list-type="picture"
      :show-file-list="false" 
      v-show="!imgUrl">
      <img class="avatar el-icon-plus" :src="imgUrl" v-show="imgUrl" />
      <i class="el-icon-plus avatar-uploader-icon"></i>
    </el-upload>

    <el-dialog :class="['dialog',filedName === 'android' ? 'w2' : 'w1']"  :visible.sync="dialogVisible" :append-to-body="true" @close="dialogVisible = false">
      <img :src="imgUrl">
    </el-dialog>

    <!-- 此处input才是上传的部分-->
    <input
      ref="fileUpload"
      accept=".png,.jpg,.jpeg,.gif"
      type="file"
      name=""
      class="file"
      @change="inputChangeHandle"
      v-show="!imgUrl" />

    <el-progress
      v-show="progressFlag"
      :percentage="progressNum"
      :width="178"
      type="circle"
      class="progress">
    </el-progress>

    <div class="media" v-if="filedName !== 'android'">
      <media-library
        :filedName="filedName"
        :show_type="show_type"
        :isShowMedia="imageMedia"
        @imgUploaded="handleMediaLibraryUpload">
      </media-library>
    </div>

  </div>
</template>

<script>
import MediaLibrary from "./MediaLibrary.vue";
import { getUploadUrl, removeObject, uploadByUrl } from "@/minio/minio";
import { getNowTime, getImgName } from "@/assets/common_js_files/publicmethods";
export default {
  props: ['imgUrl', 'filedName', 'show_type','imageMedia'],
  components: {
    MediaLibrary,
  },
  data() {
    return {
      imgSrc: '',
      dialogVisible: false,
      form: {},
      upload: false,
      url: null,
      progressNum: 0, // 进度条数值
      progressFlag: false, // 进度条显示隐藏
      isUploading: false, // 是否正在上传
      currentUpload: null, // 当前上传任务，用于取消上传
      isFromMediaLibrary: false, // 标记图片是否来自媒体库
    };
  },
  created() {
    this.imgSrc = this.imgUrl
  },
  methods: {
    imgUploadedHandle(src, success, fromMediaLibrary = false) {
      console.log("处理图片-imgUploadedHandle:>>>>>>>>>",this.filedName, src, "fromMediaLibrary:", fromMediaLibrary);
      this.imgSrc = src;
      this.isFromMediaLibrary = fromMediaLibrary;
      this.$emit("imgUploaded", src,this.filedName,() => {
        success && success()
        this.$message2('图片上传成功','success');
        this.progressFlag = false; // 上传成功后隐藏进度条
        this.progressNum = 0; // 重置进度条
      });
    },
    // 处理媒体库选择的图片
    handleMediaLibraryUpload(src, success, fromMediaLibrary) {
      console.log("处理媒体库图片:>>>>>>>>>", this.filedName, src, fromMediaLibrary);
      this.imgUploadedHandle(src, success, true); // 标记为来自媒体库
    },
    // 处理删除
    removeImgHandle() {
      console.log("removeImgHandle:>>>>>", this.filedName, "isFromMediaLibrary:", this.isFromMediaLibrary);
      
      const message = this.isFromMediaLibrary
        ? "此操作将清空当前字段的图片引用, 是否继续?"
        : "此操作将永久删除服务器的文件, 是否继续?";
      
      this.$confirm(message, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(res => {
        // 根据图片来源采取不同的删除策略
        if (this.isFromMediaLibrary) {
          // 媒体库图片：只清空引用，不删除服务器文件
          this.$emit("imgRemoved", this.filedName,() => {
            this.$refs.fileUpload.value = null;
            this.isFromMediaLibrary = false;
            this.$message2('已清空图片引用','success');
          });
        } else {
          // 用户上传图片：删除服务器文件
          removeObject(getImgName(this.imgUrl)).then(res => {
            console.log("removeObject-success:>>>>",res);
            this.$emit("imgRemoved", this.filedName,() => {
              this.$refs.fileUpload.value = null;
              this.$message2('删除成功','success');
            });
          }).catch(err => {
            console.log("removeObject-error:>>>>",err);
            this.$message({
              message: '删除失败,请重试',
              type: 'error'
            });
          });
        }
      }).catch(_ => {
        this.$message2('已取消操作','info');
      });
    },
    inputChangeHandle() {
      let file = this.$refs.fileUpload.files[0];
      if (!file) return;
      
      // 文件类型校验
      const allowedTypes = ['image/png', 'image/jpg', 'image/jpeg', 'image/gif'];
      const allowedExtensions = ['.png', '.jpg', '.jpeg', '.gif'];
      const fileName = file.name.toLowerCase();
      const fileType = file.type.toLowerCase();
      
      // 检查文件扩展名
      const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));
      // 检查MIME类型
      const hasValidMimeType = allowedTypes.includes(fileType);
      
      if (!hasValidExtension || !hasValidMimeType) {
        this.$message({
          message: '只能上传 PNG、JPG、JPEG、GIF 格式的图片文件',
          type: 'error'
        });
        this.$refs.fileUpload.value = null; // 清空文件选择
        return;
      }
      
      let fileNameWithTime = getNowTime("time") + file.name; // 获取带时间的文件名
      this.progressFlag = true; // 显示进度条
      this.isUploading = true; // 开始上传
      this.$emit('uploadStatusChange', true); // 通知父组件正在上传
      // 上传到minio
      getUploadUrl(fileNameWithTime, '1').then(res1 => {
        // 获取上传任务对象，包含promise 和abort 方法
        this.currentUpload = uploadByUrl(res1, file, (progress) => { // 添加进度回调
          this.progressNum = progress;
        });
        this.currentUpload.promise.then((result) => {
          // 如果是主动取消的上传，不做任何处理
          if (result && result.aborted) {
            return;
          }
          // 上传成功后，使用预签名URL构建最终的图片URL
          const imgUrl = this.parseImgUrl(res1);
          console.log('上传成功，图片URL:', imgUrl);
          this.imgUploadedHandle(imgUrl, null, false); // 用户上传,标记为非媒体库来源
          this.isUploading = false; // 上传完成
          this.$emit('uploadStatusChange', false); // 通知父组件上传完成
        }).catch(err => {
          this.progressFlag = false; // 上传失败隐藏进度条
          this.progressNum = 0; // 重置进度条
          this.isUploading = false; // 上传失败
          this.$emit('uploadStatusChange', false); // 通知父组件上传完成
          this.$setErrorTips(err);
        }).finally(() => {
          this.currentUpload = null; // 清除上传任务引用
        });
      }).catch(err => {
        this.progressFlag = false; // 获取上传URL失败隐藏进度条
        this.progressNum = 0; // 重置进度条
        this.isUploading = false; // 上传失败
        this.$emit('uploadStatusChange', false); // 通知父组件上传完成
        this.$setErrorTips(err);
      })
    },
    // 取消上传
    cancelUpload() {
      if (this.currentUpload && this.currentUpload.abort) {
        this.currentUpload.abort();
        this.currentUpload = null;
        this.progressFlag = false;
        this.progressNum = 0;
        this.isUploading = false;
      }
    },
    // url解析
    parseImgUrl(url) {
      return url ? url.split('?')[0] : ''
    },
    // 预览图片
    previewImg() {
      this.dialogVisible = true;
    },
  },
  beforeDestroy() {
    // 组件销毁前取消正在进行的上传
    this.cancelUpload();
  }
};
</script>
<style scoped lang="scss">
.progress {
  position: absolute;
  top: 0;
  left: 0;
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.8);
  border-radius: 6px;
}
</style>

<style scoped lang="scss">
.w1{
  width: 800px;
}
.w2{
  width: 400px;
}
.dialog{
  position: absolute !important;
  left: 50% !important;
  top: 10%;
  overflow: visible;
  transform: translateX(-50%) !important;
  img{
    display: flex;
    width: 100%;
    height: 100%;
    max-height: 90vh;
    object-fit: contain;
  }
  :deep(.el-dialog){
    width: 100% !important;
    margin: 0 !important;
  }
  :deep(.el-dialog__wrapper){
    overflow: inherit;
  }
}
/* 图片盒子 */

.imgLoadBox {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  position: relative;
  z-index: 9;
  background: #e4e4e4;
}

/* 图片遮罩 */

.imgBoxMask {
  top: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  border-radius: 6px;
}

/* 删除图标 */

.imgLoadBox > i {
  position: absolute;
  color: #fff;
  font-size: 20px;
  top: 50%;
  left: 37.5%;
  transform: translate(-50%, -50%);
  opacity: 0;
}

.imgLoadBox:hover > .imgBoxMask {
  background-color: rgba(0, 0, 0, 0.5);
  transition: all 0.5s;
}

.imgLoadBox:hover > i {
  opacity: 1;
}

.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
  border: 1px solid #ccc;
}

.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.file {
  width: 178px;
  height: 178px;
  line-height: 178px;
  opacity: 0;
  border-radius: 6px;
  position: absolute;
  top: 1px;
  left: 1px;
  outline: none;
}
.file:hover {
  cursor: pointer;
}

.media {
  margin-left: 20px;
}
</style>
